document.addEventListener("DOMContentLoaded", () => {

  function checkScrollPosition() {
    var $productBtn = $('.product-btn-row');
    var $bottomColumn = $('.bottom-column-layout');
    
    if ($productBtn.length && isElementInViewport($productBtn)) {
      $bottomColumn.fadeOut(300);
    } else {
      $bottomColumn.fadeIn(300);
    }
  }

  // 判断元素是否在视口
  function isElementInViewport(el) {
    var rect = el[0].getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // 节流函数
  function throttle(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          func.apply(context, args);
        }, wait);
      }
    };
  }

  $(window).scroll(throttle(checkScrollPosition, 200));
});
